/* ClassyPod: limit product gallery to 5 images per selected variant.
   Rule: the selected variant's featured image first, then fill with the
   remaining images (original order) up to 5 total. Everything else is hidden
   in the main gallery + thumbnails. The zoom modal still shows all media. */
(function () {
  'use strict';
  var MAX = 10;

  function mediaIdOf(attr) {
    if (!attr) return null;
    var i = attr.lastIndexOf('-');
    return i === -1 ? attr : attr.slice(i + 1);
  }

  function getVariantsFor(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(sectionId) {
    var input = document.querySelector(
      '#product-form-' + sectionId + ' input[name="id"], form[id^="product-form-' + sectionId + '"] input[name="id"]'
    );
    return input ? String(input.value) : null;
  }

  function applyToGallery(gallery, featuredMediaId) {
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('li.product__media-item[data-media-id]')
    );
    if (!slides.length) return;

    // Original order of media ids (captured from DOM order, stable across calls)
    var ids = slides.map(function (li) {
      return mediaIdOf(li.getAttribute('data-media-id'));
    });

    var allowed = [];
    if (featuredMediaId && ids.indexOf(String(featuredMediaId)) !== -1) {
      allowed.push(String(featuredMediaId));
    }
    for (var k = 0; k < ids.length && allowed.length < MAX; k++) {
      if (allowed.indexOf(ids[k]) === -1) allowed.push(ids[k]);
    }

    slides.forEach(function (li) {
      var id = mediaIdOf(li.getAttribute('data-media-id'));
      li.style.display = allowed.indexOf(id) === -1 ? 'none' : '';
    });

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    Array.prototype.forEach.call(thumbs, function (li) {
      var target =
        li.getAttribute('data-target') ||
        (li.querySelector('[data-target]') &&
          li.querySelector('[data-target]').getAttribute('data-target'));
      var id = mediaIdOf(target);
      li.style.display = allowed.indexOf(id) === -1 ? 'none' : '';
    });
  }

  function applySection(sectionId, variants) {
    var featured = null;
    if (variants) {
      var vid = currentVariantId(sectionId);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === vid) {
          if (variants[i].featured_media) featured = variants[i].featured_media.id;
          break;
        }
      }
    }
    var galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-' + sectionId + '"]');
    Array.prototype.forEach.call(galleries, function (g) {
      applyToGallery(g, featured);
    });
  }

  function init() {
    var pickers = document.querySelectorAll('variant-radios[data-section], variant-selects[data-section]');
    var covered = {};

    Array.prototype.forEach.call(pickers, function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var variants = getVariantsFor(picker);
      covered[sectionId] = true;

      var run = function () {
        applySection(sectionId, variants);
      };
      picker.addEventListener('change', function () {
        // let the theme update the hidden variant input first
        setTimeout(run, 80);
        setTimeout(run, 350);
      });
      run();
    });

    // Galleries without a variant picker (single-variant products): first 5 only
    Array.prototype.forEach.call(document.querySelectorAll('media-gallery[id^="MediaGallery-"]'), function (g) {
      var id = g.id.replace('MediaGallery-', '');
      var owned = Object.keys(covered).some(function (s) {
        return id.indexOf(s) === 0;
      });
      if (!owned) applyToGallery(g, null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
